
<div class="mensaje">
    <h3><strong>Bienvenido!</strong></h3>
    <p>Para poder continuar y utilizar el sistema IAN2,
        <br>es necesario que cambie su contraseña. 
    </p>
</div>
<div class="reset ">
    <div class="reset-triangle"></div>
    <h2 class="reset-header">Cambiar contraseña</h2>

    <form class="reset-container" (ngSubmit)="onReset()" [formGroup]="resetForm">
    <div class="form-group">
        <p><input class="form-control"
                type="password"
                autocomplete="off"
                formControlName="clave"
                placeholder="Ingresar contraseña actual"></p>
    </div>
    <div class="form-group ">           
        <p><input class="form-control"
                type="password"
                autocomplete="off"
                required minlength="6"
                formControlName="nuevaClave"
                placeholder="Ingresar nueva contraseña"></p>
    <span *ngIf="resetForm.get('nuevaClave').errors?.minlength" class="d-inline-block invalid-feedback">
    La contraseña debe tener 6 o mas caracteres
    </span>
    </div>
    <div class="form-group ">           
        <p><input class="form-control"
                type="password"
                autocomplete="off"
                required minlength="6"
                formControlName="confirmarClave"
                placeholder="Confirmar nueva contraseña"></p>
    <span *ngIf="resetForm.get('confirmarClave').errors?.minlength" class="d-inline-block invalid-feedback">
    La contraseña debe tener 6 o mas caracteres
    </span>
    </div>
        <p><button class="btn btn-warning btn-lg btn-block" type="submit">Cambiar</button></p>
    </form>
</div>
